export default "assets/images/logo_cordier_fr-d7797010.png";